import React from "react";
import { dialog } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
  aggregateUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import PayrollListlPresenter from "./PayrollListlPresenter";
import PayrollTable from "./PayrollTable/PayrollTable";
import Progress from "../../../components/Progress";
import ProgressDialog from "../../../components/common/ProgressDialog";

class PayrollListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PayrollListlPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      limit: 10,
      current: 1,
      count: 0,
      showProgressModal: false,
      saveProgress: 0,
      savedCount: 0,
      totalCount: 0,
      progressTitle: "Updating Payroll",
      progressMessage: "Updating employee records...",
      progressSuccessMessage: "Employee records updated successfully!",
      panelState: {
        isPayrollListing: false,
      },
    };
  }

  getCollectionName() {
    return "payroll_list";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async handleAction(data) {

    const isBackpay = this.presenter._isBackPay(data);
    const collectionName = isBackpay ? "payroll_back_pay" : "payroll";
    
    const pipeline = [
      {
        $match: {
          payrollID: data?.id,
        },
      },
      {
        $addFields: {
          employeeId: "$employee.id",
        },
      },
    ];

    const payrollData = await aggregateUseCase().execute(collectionName, pipeline);
    
    const ids = [];
    for (const item of payrollData) {
      const employeeId = item?.employeeId || item?.employee?.id;
      ids.push(employeeId);
    }

      this.setState((prevState) => ({
        panelState: {
          ...prevState.panelState,
          isPayrollListing: true,
          ids,
          payrollData,
          isBackpay,
        },
      }));
  }
  
  closeAction(action) {
    this.setState((prevState) => ({
      panelState: {
        ...prevState.panelState,
        [action]: false,
      },
    }));

  }

  dialogClose() {
    dialog.close();
  }

  async handleDisbursementVoucher(data) {
    const dataToBeInserted = {
      disbursementData: [data],
      payrollCode: data?.payrollCode,
    };

    try {
      const disbursementLists = await findObjectUseCase().execute(
        "disbursement",
        {
          where: { "disbursementData.id": data?.id },
        }
      );

      if (disbursementLists.length > 0) {
        this.showError("Disbursement already generated for this Payroll!");
        return;
      }

      await upsertUseCase().execute("disbursement", dataToBeInserted);
      this.showSuccess("Disbursement Successfully generated");
    } catch (error) {
      console.log(error);
    }
  }

  _onViewPayroll(object) {
    const isBackpay = this.presenter._isBackPay(object);
    this.navigateTo(`/emp/${this.getCollectionName()}/${object.id}`, {object: { ...object, isBackpay }});
  }

  handleViewPayslip = async (data) => {
    return this.presenter.getHandlePayslip(data);
  };

  async refetchData() {
    this.filterSubmit({});
    await this.presenter.getObjects();
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      loading,
      count,
      limit,
      current,
      panelState,
      showProgressModal,
      saveProgress,
      savedCount,
      totalCount,
      progressTitle,
      progressMessage,
      progressSuccessMessage,
    } = this.state;

    console.log("OBJECTS", objects);

    console.log("PANELL STATE", panelState);

    if (!schema) return <Progress />;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "createdAt" &&
        fields !== "payrollCode" &&
        fields !== "payrollType" &&
        fields !== "jobType" &&
        fields !== "payItem" &&
        fields !== "startDate" &&
        fields !== "endDate" &&
        fields !== "stats"
    );
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                  </div>
                </CardView>
              </div>

              <Table
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                progress={loading}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                viewPayroll={this._onViewPayroll.bind(this)}
                payslip={(data) => this.presenter._onGeneratePayslip(data)}
                voucher={this.handleDisbursementVoucher.bind(this)}
                remove={(data) => this.presenter._onDeleteData(data)}
                printPayslip={(data) =>
                  this.presenter._onCheckNegativeValues(data)
                }
                payroll={(data) => {
                  this.handleAction(data);
                }}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "Print Payroll List",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {panelState.isPayrollListing && (
          <PayrollTable
            payrollData={panelState.payrollData}
            ids={panelState.ids}
            isBackpay={panelState.isBackpay}
            closePayrollForm={() => {
              this.closeAction("isPayrollListing");
            }}
          />
        )}
        {/* {panelState.isConfirmationModal && (
          <ConfirmationFormPage
            data={panelState}
            onClose={() => this.presenter._setModalState(false)}
            onInputDv={(data) => this.presenter._handleDvNumber(data)}
            continue={(data) => this.presenter._confirmApproval(data)}
          />
        )} */}
        {showProgressModal && (
          <ProgressDialog
            saveProgress={saveProgress}
            savedCount={savedCount}
            totalCount={totalCount}
            title={progressTitle}
            processingMessage={progressMessage}
            successMessage={progressSuccessMessage}
            showDetails={true}
          />
        )}
      </>
    );
  }
}

export default withRouter(PayrollListPage);
